module.exports = {
      id: "angle-left-usage",
      viewBox: "0 0 192 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#angle-left",
      toString: function () {
        return this.url;
      }
    }